module.exports = __webpack_public_path__ + "img/icon-type-6.bb7bfc08.png";